/**
 * Utility to detect if given URL is video
 * Tests for mp4, webm, m4v, mpg and mpeg extensions
 */
export var isVideoExtension = function isVideoExtension(url) {
  return typeof url === 'string' && /\.(mp4|webm|m4v|mpe?g)$/.test(url);
};